export const isAbortLikeError = (error: unknown): boolean => {
  if (!error) return false;
  const maybeError = error as { name?: string; code?: string; message?: string };
  const name = String(maybeError.name || '').toLowerCase();
  const code = String(maybeError.code || '').toLowerCase();
  const message = String(maybeError.message || '').toLowerCase();

  return (
    name === 'aborterror' ||
    code === 'aborterror' ||
    message.includes('aborted') ||
    message.includes('aborterror')
  );
};

export const isPermissionDeniedError = (error: unknown): boolean => {
  if (!error) return false;
  const maybeError = error as { code?: string; message?: string };
  const code = (maybeError.code || '').toLowerCase();
  const message = (maybeError.message || '').toLowerCase();

  return (
    code.includes('permission-denied') ||
    message.includes('permission-denied') ||
    message.includes('missing or insufficient permissions')
  );
};

export const logOnce = (
  sink: Set<string>,
  key: string,
  logger: () => void
): void => {
  if (sink.has(key)) return;
  sink.add(key);
  logger();
};
